class BaseMiddleware {
	handle (from, to, next) {
		return next();
	}
}

export default BaseMiddleware;
